import React from "react";
import { registerIcons } from "@fluentui/react";
import ValidationWarningIcon from "./components/ValidationWarningIcon";
import CopilotIcon from "./components/CopilotIcon";

export const registerCustomIcons = (): void => {
  registerIcons({
    icons: {
      ValidationWarningIcon: <ValidationWarningIcon />,
      CopilotIcon: <CopilotIcon />,
    },
  });
};
